export const ROLES = ['guest', 'user', 'expert', 'admin'] as const
export type Role = (typeof ROLES)[number]

export const SOURCES = ['web', 'telegram_bot', 'telegram_mini_app', 'mobile', 'admin'] as const
export type Source = (typeof SOURCES)[number]

export const ROLE_LABELS: Readonly<Record<Role, string>> = {
  guest: 'Гость',
  user: 'Пользователь',
  expert: 'Эксперт',
  admin: 'Администратор',
}

export const SOURCE_LABELS: Readonly<Record<Source, string>> = {
  web: 'Веб',
  telegram_bot: 'Telegram-бот',
  telegram_mini_app: 'Mini App',
  mobile: 'Мобильное',
  admin: 'Админка',
}

export function roleLabel(value: string): string {
  const role = ROLES.find((r) => r === value)
  return role ? ROLE_LABELS[role] : value
}

export function sourceLabel(value: string | null): string {
  const source = SOURCES.find((s) => s === value)
  return source ? SOURCE_LABELS[source] : (value ?? '—')
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', dateStyle: 'short', timeStyle: 'short' })
}

export const ACTIVE_DAYS = [1, 7, 30] as const

export const ACTION_LABELS: Readonly<Record<string, string>> = {
  block: 'Заблокирован',
  unblock: 'Разблокирован',
  revoke_sessions: 'Сессии завершены',
  merge: 'Объединён с другим аккаунтом',
}

export const LOGIN_METHOD_LABELS: Readonly<Record<string, string>> = {
  telegram: 'Telegram',
  yandex: 'Яндекс ID',
  google: 'Google',
  vk: 'VK ID',
  email: 'Email и пароль',
}

export const USER_SOURCE_LABELS: Readonly<Record<string, string>> = {
  telegram: 'Telegram',
  telegram_trainer: 'Бот-тренажёр',
  yandex: 'Яндекс ID',
  google: 'Google',
  vk: 'VK ID',
}

export function loginMethodsLabel(methods: readonly string[]): string {
  return methods.length > 0 ? methods.map((m) => LOGIN_METHOD_LABELS[m] ?? m).join(', ') : 'нет'
}

export const ORDER_STATUS_LABELS: Readonly<Record<string, string>> = {
  pending: 'Ждёт разбора',
  ready: 'Готов',
  rejected: 'Отклонён',
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow', dateStyle: 'medium' })
}

export function relativeSeen(iso: string | null): string {
  if (!iso) return 'не заходил'
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000)
  if (minutes < 5) return 'сейчас'
  if (minutes < 60) return `${minutes} мин назад`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} ч назад`
  const days = Math.round(hours / 24)
  return days === 1 ? 'вчера' : `${days} дн назад`
}
